import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import MainLayout from 'src/layouts/main';

// ----------------------------------------------------------------------

const LandingPage = lazy(() => import('src/pages/landing'));
const AboutUsPage = lazy(() => import('src/pages/about-us'));
const ContactPage = lazy(() => import('src/pages/contact'));
const PrivacyPolicyPage = lazy(() => import('src/pages/privacy-policy'));
const TermsOfServicePage = lazy(() => import('src/pages/terms-of-service'));
const FaqsPage = lazy(() => import('src/pages/faqs'));
const PricingPage = lazy(() => import('src/pages/pricing'));

// ----------------------------------------------------------------------

export const landingRoutes = [
  {
    path: '/',
    element: (
      <MainLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      {
        element: <LandingPage />,
        index: true,
      },
      { path: 'about-us', element: <AboutUsPage /> },
      { path: 'contact-us', element: <ContactPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms-of-service', element: <TermsOfServicePage /> },
      { path: 'faqs', element: <FaqsPage /> },
      { path: 'pricing', element: <PricingPage /> },
    ],
  },
];
